// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* Sin acciones en la fila: no hace falta reservar la columna flotante de mobile */\n.my-account-user[data-v-fd71e56e] {\n  padding-right: 18px;\n}\n.my-account-options[data-v-fd71e56e] {\n  border-radius: 10px;\n  overflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
